export interface DesktopClient {
  platform?: string;

  version?: number;

  logout?: () => void;

  loadURL?: (url: string) => void;
  openExternalURL?: (url: string) => void;

  addTab?: (url?: string) => void;
  addInitialTab?: (url?: string) => void;
  closeTab?: (id: number) => void;
  forwardInTab?: (id: number) => void;
  backInTab?: (id: number) => void;
  focusTab?: (id: number) => void;
  onTabChange?: (handler: (state: TabBarState) => void) => void;
  moveTab?: (sourceIndex: number, destinationIndex: number) => void;
  openTabContextMenu?: (id: number) => void;
  reloadAllTabs?: () => () => void;
  setDesktopTabIcon?: (iconUrl: string) => void;

  onIframeBlock?: (name: string, handler: () => void) => () => void;
  toggleTitleBarMenu?: () => void;

  changeTheme?: (theme: string) => void;
  onThemeChange?: (handler: (theme: string) => void) => void;
}

declare global {
  interface Window {
    desktop?: DesktopClient;
  }
}

export type TabItem = {
  id: number;
  title: string;
  focusedTime: number;
  icon: string;
  iconUrl: string;
  url: string;
};

export type TabBarState = {
  tabs: TabItem[];
  focusedTabId: number;
  canGoForward: boolean;
  canGoBack: boolean;
};

export const DesktopPlatforms = {
  mac: 'darwin',
  windows: 'win32',
};

export const isElectron = Boolean(
  typeof window !== 'undefined' && window.desktop,
);
